module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABGElEQVQokY3RvyvFURjH8df9svqVuhSRLMpgQKIsJIvFIDKoWwZ/iO5gMbBYbAwGq/woFqWwGmVAKeXHZvBjuM9XJ6H71Knz+TzP+5zzPKfQe1SewQaa/B9PWMIOZFivAhI1a7nIUKwCyuO7tjYxz/HyB9CIgdRIwWnc/QEWAu7LjSxJ3uIz1hMmk1zunfwG5vGOKeyjDZtx6B220P0TfMG1ypRPAzpDCYdoxbzKLHrSHkdwlehltMe+hDF0qHxLOb1xDxdoDj3xSxt5jKdgB/pRF/ojyWUYjf5W8FEbvTUkRV24URnOYnjHeIj9IA5qigvjb/GsQiQecYBLzKEeneiN9YnZDKtoiWd0h4Z7DGMbz3jFLoZw/QW2vTe7edPwYQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/alarm/receiving-time-icon.png
// module id = t/HY
// module chunks = 1